import { useState, useRef } from "react";
import * as React from "react";
import styled, { keyframes, css } from "styled-components";
import Popover from "components/common/Popover";
const HOTSPOT_HEIGHT = 80;
const hotspotExpand = keyframes`
  0% {
    transform: scale(.5);
    opacity: 1;
  }
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
`;
const HotspotTrigger = styled.button(
  ({ theme }) => css`
    && {
      border-radius: 50%;
      height: ${HOTSPOT_HEIGHT}px;
      width: ${HOTSPOT_HEIGHT}px;
      background: ${theme.colors.variant.warning};
      color: ${theme.utils.contrastingColor(theme.colors.variant.warning)};
      border: 0;
      font-size: ${theme.fonts.size.huge};

      &:hover {
        background: ${theme.colors.variant.warning};
        color: ${theme.utils.contrastingColor(theme.colors.variant.warning)};
      }
    }

    &::before {
      background: ${theme.colors.variant.warning};
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: -1;
      opacity: 0;
      animation: ${hotspotExpand} 2s infinite;
      border-radius: 50%;
      left: 0;
      top: 0;
    }
  `
);
const HotspotContainer = styled.div(
  ({ $positionX, $positionY }) => css`
    position: absolute;
    top: ${$positionY};
    left: calc(${$positionX} - ${HOTSPOT_HEIGHT / 2}px);
  `
);
const Hotspot = ({ children = void 0, positionX, positionY, index }) => {
  const [show, setShow] = useState(false);
  const target = useRef();
  const container = useRef();
  const showPopover = () => setShow(true);
  const hidePopover = () => setShow(false);
  return /* @__PURE__ */ React.createElement(HotspotContainer, { $positionX: positionX, $positionY: positionY, ref: container }, /* @__PURE__ */ React.createElement(Popover, { opened: show, position: "bottom", id: "session-badge-details", width: 275 }, /* @__PURE__ */ React.createElement(Popover.Target, null, /* @__PURE__ */ React.createElement(
    HotspotTrigger,
    {
      onMouseOver: showPopover,
      onMouseOut: hidePopover,
      onFocus: showPopover,
      onBlur: hidePopover,
      ref: target
    },
    index + 1
  )), /* @__PURE__ */ React.createElement(Popover.Dropdown, null, children)));
};
export default Hotspot;
